import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { apiFetch } from '@/core';
import env from '@/env';
import { AuditorProposalCompItem } from '../types';

export const createAuditorProposalComp = async ({
  auditorProposalId,
  auditorCompId,
}: {
  auditorProposalId: string;
  auditorCompId: string;
}): Promise<AuditorProposalCompItem> => {
  const fetchResponse = await apiFetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/auditor-proposals/${auditorProposalId}/auditor-proposal-comps`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        auditorCompId,
      }),
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditorProposalCompItem;
  return response;
};
